import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WmsItemHdrContainer } from "../../../../../models/aggregates/warehouse/index";
import { ApiResponseModel } from "../shared";
import { ApiVisa } from "../shared";
import { Observable } from 'rxjs';

@Injectable({ providedIn: "root" })
export class WmsItemHdrService extends BaseApiTemplateService<WmsItemHdrContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "/warehouse-item-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouse-item-hdrs/backoffice-ep";
    this.httpClient = http;
  }

  public getWmsItemsByCriteria(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
